import { ApiError } from "./_utils";
import { DS_COLLECTION } from "./_constants";

const FileUpload = async(data) => {
    const onLive = document.getElementById("token");
    const hasFile = data && "file" in data ? data.file : null;
    const newData = {...data };
    if (hasFile) {
        delete newData.file;
    }
    if (hasFile && hasFile.type === "add") {
        const { name, fileContent } = hasFile;

        const localFileUpload = () => {
            newData[name] = ["1234", "examplefile.pdf", "https://example.com"];
            return newData;
        };

        const localFakeUpload = new Promise((resolve) => {
            setTimeout(() => resolve(localFileUpload()), 3000);
        });

        const productionUpload = new Promise((resolve) => {
            matrixCreateAsset(fileContent).then((response) => {
                const { asset_id, name: asset_name, web_path } = response[2];
                newData[name] = [asset_id, asset_name, web_path];
                // console.log(asset_id, name, web_path);
                // console.log(newData);
                resolve(newData);
            });
        });

        if (onLive) {
            return productionUpload;
        } else {
            return localFakeUpload;
        }
    } else {
        return newData;
    }
};

async function matrixCreateAsset(fileInput) {
    const fileData = fileInput[0];
    const fileName = fileInput[0].name;

    function readAs(file, as) {
        if (!(file instanceof Blob)) {
            throw new TypeError("Must be a File or Blob");
        }

        return new Promise(function(resolve, reject) {
            var reader = new FileReader();
            reader.onload = function(e) {
                resolve(e.target.result);
            };
            reader.onerror = function(e) {
                reject(
                    new Error(
                        "Error reading" + file.name + ": " + e.target.result
                    )
                );
            };
            reader["readAs" + as](file);
        });
    }

    function readAsDataURL(file) {
        return readAs(file, "DataURL");
    }

    // Create user folder in matrix
    const createUserFolder = (name) => {
        return js_api.createAsset({
            parent_id: 2371,
            type_code: "folder",
            asset_name: name,
            link_type: 1,
            link_value: "cv-builder",
            sort_order: -1,
            is_dependant: 0,
            is_exclusive: 0,
            extra_attributes: 0,
            attributes: 0,
            dataCallback: (response) => {
                datastore
                    .collection("users")
                    .doc(currentUser.userid)
                    .update({
                        userid: currentUser.userid,
                        name: currentUser.name,
                        folderId: parseInt(response.id),
                    });
            },
        });
    };

    // Check if the current user has a folder or create one
    const userFolder = () => {
        return new Promise((resolve) => {
            datastore
                .collection("users")
                .get()
                .then((user) => {
                    const userInfo = user[0];
                    const folder =
                        "folderId" in userInfo && userInfo.folderId ?
                        { id: userInfo.folderId } :
                        createUserFolder(userInfo.name);

                    resolve(folder);
                });
        });
    };

    const getAssetId = (res) => {
        return Object.keys(res)[0];
    };

    // Create matrix file asset
    const createMatrixFile = () => {
        const extension = fileName.split(".");

        return new Promise((resolve) => {
            userFolder().then((parentFolder) => {
                js_api.createFileAsset({
                    parentID: parentFolder.id,
                    type_code: "file",
                    friendly_name: extension[0] + "-" + Date.now() + "." + extension[1],
                    link_type: 1,
                    dataCallback: (response) => {
                        return updateFileContent(
                            fileData,
                            getAssetId(response)
                        ).then((data) => {
                            resolve(data);
                        });
                    },
                });
            });
        });
    };

    // Update file
    const updateFileContent = (filebase64, assetId) => {
        const file = readAsDataURL(filebase64);

        return new Promise((resolve) => {
            file.then((res) => {
                let fileData = res.split(",");
                fileData.shift();
                resolve(
                    js_api.batchRequest({
                        functions: {
                            0: {
                                function: "acquireLock",
                                args: {
                                    asset_id: assetId,
                                    screen_name: "all",
                                    dependants_only: 0,
                                    force_acquire: 1,
                                },
                                blocking: 1,
                            },
                            1: {
                                function: "updateFileAssetContent",
                                args: {
                                    asset_id: assetId,
                                    content: fileData[0],
                                },
                            },
                            2: {
                                function: "getGeneral",
                                args: {
                                    asset_id: assetId,
                                    get_attributes: 1,
                                },
                                blocking: 1,
                            },
                        },
                    })
                );
            });
        });
    };

    try {
        const createFile = await createMatrixFile();
        return await createFile;
    } catch (error) {
        console.log(error);
    }
}

const datastoreAPI = datastore.collection("users");

export const cvActions = async(state) => {
    const { id, field, data, type } = state;
    try {
        const dataStoreActions = (adjustedData) => {
            let action = datastoreAPI.doc(currentUser.userid);
            let collection = (collection = DS_COLLECTION[field]);

            switch (type) {
                case "get":
                    {
                        const profileData = datastoreAPI.get();
                        const experienceData = action
                            .collection("experiences")
                            .get();
                        const achievementData = action
                            .collection("achievements")
                            .get();
                        const educationData = action
                            .collection("education")
                            .get();
                        const supplementData = action
                            .collection("supplements")
                            .get();
                        const wowExperienceData = action
                            .collection("wowchallenge")
                            .get();

                        action = Promise.all([
                            profileData,
                            experienceData,
                            achievementData,
                            educationData,
                            supplementData,
                            wowExperienceData,
                        ]);
                    }
                    break;
                case "add":
                    {
                        action = action
                        .collection(collection)
                        .add(adjustedData);
                    }
                    break;
                case "update":
                    {
                        if (field !== "userProfile") {
                            action = action
                                .collection(collection)
                                .doc(id)
                                .update(adjustedData);
                        } else {
                            action = action.update(adjustedData);
                        }
                    }
                    break;
                case "remove":
                    {
                        action = action.collection(collection).doc(id).delete();
                    }
            }
            return action;
        };

        const newDataObj = await FileUpload(data);
        const updateDatastore = await dataStoreActions(newDataObj);
        return updateDatastore;
    } catch (e) {
        return new ApiError(e);
    }
};

export const wowActions = async(state) => {
    const { id, data, type } = state;
    try {
        let action = datastoreAPI
            .doc(currentUser.userid)
            .collection("wowchallenge");

        switch (type) {
            case "get":
                {
                    const profileData = datastoreAPI.get();
                    const wowData = action.get();

                    action = Promise.all([profileData, wowData]);
                }
                break;
            case "add":
                {
                    const newCVexp = {
                        expOrg: data.expName,
                        expTitle: "",
                        expType: data.expType[0] === "Paid employment" ?
                            ["Employment"] :
                            data.expType,
                        startDate: data.startDate,
                        endDate: data.endDate,
                        expResponsibilities: [],
                    };
                    const addToWow = action.add(data);
                    const addToCV = cvActions({
                        field: "wowExp",
                        data: newCVexp,
                        type: "add",
                    });

                    action = Promise.all([addToWow, addToCV]);
                }
                break;
            case "update":
                {
                    action = action.doc(id).update(data);
                }
                break;
            case "remove":
                {
                    action = action.doc(id).delete();
                }
        }

        return action;
    } catch (e) {
        return new ApiError(e);
    }
};

export const wowAwardAction = async(state) => {
    const { id, wowState } = state;
    let action = datastoreAPI.doc(currentUser.userid);
    try {
        switch (wowState) {
            case 50:
                {
                    const newCVaward = {
                        achieveTitle: "World of Work(WOW)",
                        achieveDescription: "Challenge completion: 50 hours",
                        achieveType: ["Award"],
                        achieveFile: ["wow", "WOW Challenge.pdf", "50"],
                    };

                    const createAwardInCv = cvActions({
                        field: "awards",
                        data: newCVaward,
                        type: "add",
                    });
                    action = new Promise((resolve) => {
                        createAwardInCv.then((award) => {
                            datastoreAPI
                                .doc(currentUser.userid)
                                .update({
                                    userid: currentUser.userid,
                                    name: currentUser.name,
                                    wowChallenge: ["50", award.id],
                                })
                                .then((response) => {
                                    resolve(response);
                                });
                        });
                    });
                }
                break;
            case 100:
                {
                    const updateCVaward = {
                        achieveTitle: "World of Work(WOW)",
                        achieveDescription: "Challenge completion: 100 hours",
                        achieveType: ["Award"],
                        achieveFile: ["wow", "WOW Challenge.pdf", "100"],
                    };

                    const updateUserWowField = action.update({
                        userid: currentUser.userid,
                        name: currentUser.name,
                        wowChallenge: ["100", id],
                    });

                    const updateAward = cvActions({
                        id,
                        field: "awards",
                        data: updateCVaward,
                        type: "update",
                    });

                    action = Promise.all([updateUserWowField, updateAward]).then(
                        (response) => {
                            return response[0];
                        }
                    );
                }
        }

        return action;
    } catch (e) {
        return new ApiError(e);
    }
};

export const enterDrawAction = async() => {
    try {
        let enterDrawUrl =
            "https://studentpathways.sa.edu.au/wow-challenge?enterdraw=true";

        const action = fetch(enterDrawUrl, {
            credentials: "include",
        }).then((response) => {
            return response.text();
        });

        return action;
    } catch (e) {
        return new ApiError(e);
    }
};

export const adminActions = async() => {
    try {
        const action = new Promise((resolve) => {
            datastore
                .collection("users")
                .get()
                .then((data) => {
                    // console.log(data);
                    let block = 100; // every 250
                    let multiplier = 0;

                    let allUserData = [];
                    // const test = data.map((user, ui) => {
                    //     if (ui > block) {
                    //         multiplier++;
                    //         block = block * multiplier;
                    //         console.log(block, multiplier, delay);
                    //     }

                    //     return new Promise((resolve) => {
                    //         setTimeout(() => {
                    //             resolve(
                    //                 datastore
                    //                 .collection("users")
                    //                 .doc(user.userid)
                    //                 .collection("wowchallenge")
                    //                 .get()
                    //             );
                    //         }, delay);
                    //     });
                    // });
                    data.forEach((user, ui) => {
                        let delay = 5000 * multiplier; // 5seconds
                        if (ui > block) {
                            multiplier++;
                            block = 100 * multiplier;
                            // console.log(block, multiplier, delay);
                        }

                        const userData = new Promise((resolve) => {
                            setTimeout(() => {
                                resolve(
                                    datastore
                                    .collection("users")
                                    .doc(user.userid)
                                    .collection("wowchallenge")
                                    .get()
                                );
                            }, delay);
                        });
                        allUserData.push(userData);
                    });
                    // console.log(block, multiplier);
                    // console.log(test);
                    // console.log(allUserData);
                    const allWowData = Promise.all(allUserData).then(
                        (values) => {
                            return { profiles: data, wowData: values };
                        }
                    );
                    resolve(allWowData);
                });
        });

        return action;
    } catch (e) {
        return new ApiError(e);
    }
};